import React, { useState, useRef, useContext, useEffect } from "react";
import "./styles/styles.css";
import "../../styles/global.css";
import { images } from "../../constants";
import { validateString } from "../../utils/validateString";
import { useNavigate } from "react-router-dom";
import {
  verifyEmailAndPassword,
  loginWithCode,
  fetchWithoutToc,
  resolveErrorMessage,
} from "../../utils/methods";
import { apiRoutes } from "../../utils/apiRoutes";
import Loader from "../../components/Loader/Loader";
import { TranslationsContext } from "../../utils/TranslationsContext";
import FirstStep from "./components/FirstStep";
import SecondStep from "./components/SecondStep";
import { useParams } from "react-router-dom";
import { useAlert } from "../../utils/AlertContext";
import ExpandableText from "../../components/TableFirst/components/ExpandableText";
import { icons } from "../../constants";
import { formatDate } from "../../utils/formatDate";
import Modal from "../../components/Modal/Modal";

const LoginSinglePage = () => {
  const { id } = useParams();
  console.log("id", id);
  const [isLoading, setIsLoading] = useState(false);
  const [openForgotPassword, setOpenForgotPassword] = useState(false);
  const [isOpenAddUser, setIsOpenAddUser] = useState(false);
  const [userId, setUserId] = useState();
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });
  const [step, setStep] = useState(1);
  const [code, setCode] = useState(new Array(6).fill(""));
  const [errors, setErrors] = useState({
    email: false,
    password: false,
    code: false,
  });
  const inputsRef = useRef([]);
  const submitButtonRef = useRef(null);
  const nextButtonRef = useRef(null);
  const { showAlert } = useAlert();
  const [eventInfo, setEventInfo] = useState();

  useEffect(() => {
    const fetchEventInfo = async () => {
      try {
        setIsLoading(true);

        const result = await fetchWithoutToc(
          apiRoutes.getEventInfo.replace(":id", id),
        );

        if (!result) return;
        const data = await result.json();
        console.log("data", data);
        setEventInfo(data);
      } catch (err) {
        console.error("Error fetching events:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchEventInfo();
  }, []);

  const handleInputChange = (field, value) => {
    setCredentials((prev) => ({
      ...prev,
      [field]: value,
    }));
    setErrors((prev) => ({ ...prev, [field]: false }));
  };

  useEffect(() => {
    if (step === 2 && inputsRef.current[0]) {
      inputsRef.current[0].focus();
    }
  }, [step]);

  const handleNext = async () => {
    setIsLoading(true);
    const validEmail = credentials.email !== "";
    // const validEmail = !validateString(credentials.email, "e_mail");
    const validPassword = credentials.password !== "";

    if (validEmail && validPassword) {
      const response = await verifyEmailAndPassword(
        apiRoutes.verifyEmailPassword,
        credentials.email,
        credentials.password,
      );

      console.log(response);
      if (response?.status && response?.complete) {
        setErrors({ email: false, password: false, code: false });
        setStep(2);
      } else if (response?.status && !response?.complete) {
        setUserId(response.id);
        setIsOpenAddUser(true);
      } else {
        showAlert(
          resolveErrorMessage(response?.error, t, "ERROR_INTERNAL_SERVER_ERROR"),
          "error",
        );
      }
    } else {
      setErrors({
        email: !validEmail,
        code: false,
        password: !validPassword,
      });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (code.join("").length === 6) {
      setTimeout(() => {
        console.log("cao");
        handleLogin(code.join(""));
      }, 100);
    }
  }, [code]);

  const handleCodeChange = (index, value) => {
    const updatedCode = [...code];

    if (/^[0-9]$/.test(value)) {
      updatedCode[index] = value;
      setCode(updatedCode);

      if (index < 5) {
        inputsRef.current[index + 1]?.focus();
      } else if (index === 5) {
        submitButtonRef.current?.focus();
      }
    } else if (value === "") {
      updatedCode[index] = value;
      setCode(updatedCode);

      if (index > 0) {
        inputsRef.current[index - 1]?.focus();
      }
    }

    setErrors((prev) => ({ ...prev, code: false }));
  };

  const handleVerifyCode = async (enteredCode) => {
    setIsLoading(true);
    if (enteredCode.length === 6) {
      try {
        const response = await loginWithCode(
          apiRoutes.verifyCode,
          credentials.email,
          enteredCode,
        );
        if (response?.token) {
          console.log(
            "/event/" + id + "?single=true",
            `/event/${id}?single=true`,
          );
          localStorage.setItem("authToken", response?.token);
          localStorage.setItem("single", "true");
          window.dispatchEvent(new Event("auth-token-changed"));
          navigate(`/event/${id}?single=true`);
        } else {
          setErrors((prev) => ({ ...prev, code: true }));
          showAlert(
            resolveErrorMessage(response?.error, t, "ERROR_INTERNAL_SERVER_ERROR"),
            "error",
          );
        }
      } catch (error) {
        console.error("Greška prilikom provere koda:", error);
        setErrors((prev) => ({ ...prev, code: true }));
      }
    } else {
      setErrors((prev) => ({ ...prev, code: true }));
    }
    setIsLoading(false);
  };

  const handleLogin = (enteredCode) => {
    handleVerifyCode(enteredCode);
  };

  const navigate = useNavigate();

  const { t } = useContext(TranslationsContext);
  return (
    <React.Fragment>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="flex-direction-column gap-24 items-center justify-center login-container">
          <div className="flex-direction-row gap-18 items-center">
            <img src={images.logo} alt="logo" className="flag" />
            <h1 className="font-36 inria-sans-300 login-title">
              {t("ACCREDITATION_TITLE")}
            </h1>
          </div>
          <div className="flex-direction-row gap-40 login-single-form">
            {eventInfo && (
              <div
                className="flex-direction-column gap-18 login-event-info"
                style={{ marginTop: "16px" }}
              >
                <div className="flex-direction-column gap-36">
                  {" "}
                  <ExpandableText text={eventInfo.naziv} className="font-20" />
                  <div className="flex-direction-row gap-4 inria-sans-400 font-14">
                    <img src={icons.calendar} width={16} height={16} alt="" />
                    <p>{formatDate(eventInfo.trajanje_od)}</p>
                    <p>-</p>
                    <p>{formatDate(eventInfo.trajanje_do)}</p>
                  </div>
                </div>

                <div className="flex-direction-row items-center gap-4">
                  <img src={icons.location_pin} width={16} height={16} alt="" />
                  <ExpandableText
                    text={eventInfo.lokacija}
                    className="font-16"
                  />
                </div>
                <div className="flex-direction-column gap-4 justify-start">
                  <p
                    className="inria-sans-400 font-14"
                    style={{ width: "fit-content", color: "var(--text-gray)" }}
                  >
                    {t("REGISTRATION_PERIOD")}
                  </p>
                  <div className="flex-direction-row gap-4 inria-sans-400 font-14">
                    <img src={icons.calendar} width={16} height={16} alt="" />
                    <p>{formatDate(eventInfo.prijava_od)}</p>
                    <p>-</p>
                    <p>{formatDate(eventInfo.prijava_do)}</p>
                  </div>
                </div>
              </div>
            )}
            {eventInfo && <div className="login-line"> </div>}

            <div className="flex-direction-column gap-60 login-right">
              <div className="flex-direction-column gap-12">
                {step === 1 ? (
                  <FirstStep
                    t={t}
                    handleInputChange={handleInputChange}
                    credentials={credentials}
                    errors={errors}
                    nextButtonRef={nextButtonRef}
                    handleNext={handleNext}
                  />
                ) : (
                  <SecondStep
                    t={t}
                    code={code}
                    errors={errors}
                    handleCodeChange={handleCodeChange}
                    inputsRef={inputsRef}
                    handleLogin={handleLogin}
                    submitButtonRef={submitButtonRef}
                  />
                )}
                <p
                  className="font-16 inria-sans-300 login-forgot-pass"
                  onClick={() => setOpenForgotPassword(true)}
                >
                  {t("UI_FORGOT_YOUR_PASSWORD")}
                </p>
              </div>
              <div className="flex-direction-row items-center justify-between width-100 progress-bar-container">
                <div
                  className={`progress-bar-line ${step >= 1 ? "active" : ""}`}
                ></div>
                <div
                  className={`progress-bar-step ${step >= 1 ? "active" : ""}`}
                >
                  1
                </div>
                <div
                  className={`progress-bar-line ${step >= 2 ? "active" : ""}`}
                ></div>
                <div
                  className={`progress-bar-step ${step === 2 ? "active" : ""}`}
                >
                  2
                </div>
              </div>
            </div>
          </div>
          <div className="login-footer">
            <p className="font-14 inria-sans-300">
              &copy; {t("RIGHTS_RESERVED")}
            </p>
          </div>
        </div>
      )}
      {openForgotPassword && (
        <Modal
          type="forgot-password"
          onCloseClick={() => setOpenForgotPassword(false)}
        />
      )}
      {isOpenAddUser && (
        <Modal
          type="user"
          onCloseClick={() => {
            setIsOpenAddUser(false);
          }}
          loginUser
          editing={true}
          object={{ id: userId }}
        />
      )}
    </React.Fragment>
  );
};

export default LoginSinglePage;
